import { jsxs as R, jsx as e } from "react/jsx-runtime";
import { BaseInput as y } from "./index.es600.js";
import B from "classnames";
import { noop as c, debounce as E } from "lodash/fp";
import { forwardRef as N, useState as _, useCallback as i } from "react";
import m from "./index.es601.js";
import { SearchIcon as b } from "./index.es325.js";
import { LoadingBar as j } from "./index.es63.js";
const k = "slim-search", H = N(
  ({
    testId: p = k,
    rightLeftPadding: o = "8px",
    size: f,
    isLoading: u = !1,
    CTA: t,
    disableLoading: a,
    onChange: n = c,
    onBlur: l = c,
    ...I
  }, h) => {
    const [S, r] = _(u), d = B(m.slimSearch, m[`${f}`]), x = {
      "--left-right-padding-size": o
    }, g = i(
      (s) => {
        a || r(!0), n(s), E(1e3, () => {
          r(!1);
        })();
      },
      [a, n]
    ), C = i(
      (s) => {
        r(!1), l(s);
      },
      [l]
    );
    return /* @__PURE__ */ R("div", { className: d, style: x, children: [
      /* @__PURE__ */ e(
        y,
        {
          ...I,
          testId: p,
          RightIcon: t || /* @__PURE__ */ e(b, { color: "blue", outline: "default-gray" }),
          rightIconPosition: o === "8px" ? "0px" : o,
          onBlur: C,
          onChange: g,
          allowRightIconClick: !!t,
          ref: h
        }
      ),
      S && /* @__PURE__ */ e(j, {})
    ] });
  }
);
export {
  k as SLIM_SEARCH_DEFAULT_TESTID,
  H as SlimSearch
};
//# sourceMappingURL=index.es145.js.map
